import { Icon } from '../Icon';
import type { IconProps } from '../types';

export function CrownIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M4.8 22.6a1.2 1.2 0 0 1 0-2.4h14.4a1.2 1.2 0 1 1 0 2.4zm.337-4.2a1.8 1.8 0 0 1-1.778-1.518L2.07 8.77a.7.7 0 0 0-.135.015.7.7 0 0 1-.135.015q-.75 0-1.275-.525A1.74 1.74 0 0 1 0 7q0-.75.525-1.275T1.8 5.2t1.275.525T3.6 7q0 .21-.045.39t-.105.33L7.2 9.4l3.75-5.13q-.33-.24-.54-.63t-.21-.84q0-.75.525-1.275T12 1t1.275.525T13.8 2.8q0 .45-.21.84t-.54.63L16.8 9.4l3.75-1.68a3 3 0 0 1-.105-.33Q20.4 7.21 20.4 7q0-.75.525-1.275T22.2 5.2t1.275.525T24 7t-.525 1.275T22.2 8.8a.7.7 0 0 1-.135-.015.7.7 0 0 0-.135-.015l-1.289 8.112a1.8 1.8 0 0 1-1.778 1.518zM5.64 16h12.72l.78-5.01-3.15 1.38L12 6.88l-3.99 5.49-3.15-1.38z" />
    </Icon>
  );
}

CrownIcon.displayName = 'CrownIcon';
